import { withLoyaltyStore } from "../../utils/withLoyaltyStore";

import { Prize as PrizeBase } from "./Prize";

export type * from "./Prize";
export const Prize = withLoyaltyStore(PrizeBase, "Prize");
